module.exports = __webpack_public_path__ + "img/zhuzaonft.749e141f.png";